<section class="fxt-template-animation fxt-template-layout4 loaded">
  <div class="container-fluid" style="height: calc(100vh - 32px);padding: 0px;">
      <div class="d-flex flex-wrap flex-sm-column flex-column flex-md-column flex-lg-column flex-xl-row resp-height">
          <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-7 pd-l-0 pd-r-0 tel">
              <div id="cf3" class="col-12">
                  <img src="assets/Agora-new-login-page-version-1-left.jpg" class="lft-img-align bottom" />
                  <img src="assets/Agora-new-login-left-img-2.jpg" class="lft-img-align top" />
                  <div class="banner-cntnt-align col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                      <div class="fxt-transformY-50 fxt-transition-delay-2">
                          <h1>Effective meetings without the hassle!</h1>
                      </div>
                      <div class="fxt-transformY-50 fxt-transition-delay-3">
                          <p class="p-banner-info">Revamp the way you have meetings with powerful electronic tools to
                              facilitate
                              meetings.
                          </p>
                      </div>
                      <div class="fxt-transformY-50 fxt-transition-delay-3">
                          <p class="p-banner-info">
                              The perfect way to organize and keep track of your meetings and meeting notes.
                          </p>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column justify-content-center mar-t">
              <div class="col-12 justify-content-start">
                    <img src='assets/Agora logo.png' class="logo-img p-10" />
              </div>
              <div class="col-12">
                  <h2 class="margin-0 p-10" style="font-size: 2.5em;">Agora Password Creation</h2>
              </div>
              <div class="col-12" style="height: calc(100vh - 215px);
                overflow-y: auto; overflow-x: hidden;">

                <div *ngIf = "passExpLabel != undefined && passExpLabel != null && passExpLabel != ''">
                  <span class="passExpired">{{passExpLabel}}</span>
                </div>
                    <div class="fxt-form p-10" *ngIf = "ifSecQuestionAvail == false">
                        <form [formGroup]="newPasswordForm" novalidate (ngSubmit)="submitNewPassword()">
                            <div class="example-container-passwordcreation">
                              <p>
                                  <!--password input filed-->
                                  <mat-form-field class="field" style="width: 100%">
                                    <mat-label>Old Password</mat-label>
                                    <input matInput required
                                          type="password" formControlName = "oldPassword" [ngClass]="{ 'is-invalid': isSubmitted && f.oldPassword.errors }">
                                    <mat-error *ngIf="newPasswordReg('oldPassword', 'required')">Old Password is required</mat-error>
                                  </mat-form-field>
                              </p>  
                              <p style="margin-bottom: 19px;">

                                <!--password input filed-->
                                <mat-form-field class="field" style="width: 100%">
                                  <mat-label>New Password</mat-label>
                                  <!-- <mat-pass-toggle-visibility #toggle matSuffix></mat-pass-toggle-visibility> -->
                                  <input required #newPassword matInput 
                                        type="password" formControlName = "newPassword" [ngClass]="{ 'is-invalid': isSubmitted && f.newPassword.errors }" (focus) = "toggler(true)" (blur) = "toggler(true)">
                                  <mat-hint aria-live="polite">
                                    {{newPassword.value.length}} / {{ passwordPolicyMap['Max Password Length'] }}
                                  </mat-hint>
                                  <mat-error *ngIf="newPasswordReg('newPassword', 'required')">New Password is required</mat-error>
                                </mat-form-field>
                                <!--@angular-material-extensions/password-strength's main component-->
                                <mat-password-strength #passwordComponent
                                                       [max]="passwordPolicyMap['Max Password Length']"
                                                      (onStrengthChanged)="onStrengthChanged($event)"
                                                      [password]="newPassword.value">
                                </mat-password-strength>
                                <!--Password's strength info-->
                                <mat-password-strength-info
                                  *ngIf="showDetails"
                                  [passwordComponent]="passwordComponent">
                                </mat-password-strength-info>
                              </p>
                              <p>
                                <mat-form-field  class="example-full-width field" style="width: 100%">
                                  <mat-label>Confirm Password</mat-label>
                                  <input required matInput type="password" formControlName = "confirmPassword" [ngClass]="{ 'is-invalid': isSubmitted && f.confirmPassword.errors }">
                                  <mat-error *ngIf="newPasswordReg('confirmPassword', 'required')">Confirm Password is required</mat-error>
                                  <mat-error *ngIf="newPasswordReg('confirmPassword', 'confirmedValidator')">Password must match</mat-error>
                                </mat-form-field>
                              </p>
                              <div class="text-center">
                                <button mat-raised-button color = "primary" class="text-uppercase btn btn-agora btn-lg" type="submit">Save</button>
                              </div>
                            </div>
                        </form>
                    </div>
                    <div class="fxt-form p-10" *ngIf = "ifSecQuestionAvail == true">
                      <form [formGroup]="secQuesTriggerForm" novalidate (ngSubmit)="secQuesTriggerFormSubmission()">
                          <div class="example-container-passwordcreation">  
                            <p style="margin-bottom: 19px;">
                              <!--password input filed-->
                              <mat-form-field class="adc-w-100 password">
                                <mat-label>New Password</mat-label>
                                <!-- <mat-pass-toggle-visibility #toggle matSuffix></mat-pass-toggle-visibility> -->
                                <input required #password matInput 
                                      type="password" formControlName = "password" [ngClass]="{ 'is-invalid': isSubmitted && j.password.errors }" (focus) = "toggler(true)" (blur) = "toggler(true)">
                                <mat-hint aria-live="polite">
                                  {{password.value.length}} / {{ passwordPolicyMap['Max Password Length'] }}
                                 </mat-hint>
                                <mat-error *ngIf="checkPasswordReg('password', 'required')">Password is required</mat-error>
                              </mat-form-field>
                              <!--@angular-material-extensions/password-strength's main component-->
                              <mat-password-strength #passwordComponent
                                                     [max]="passwordPolicyMap['Max Password Length']"
                                                    (onStrengthChanged)="onStrengthChanged($event)"
                                                    [password]="password.value">
                              </mat-password-strength>
                              <!--Password's strength info-->
                              <mat-password-strength-info
                                *ngIf="showDetails"
                                [passwordComponent]="passwordComponent">
                              </mat-password-strength-info>
                            </p>
                            <p>
                              <mat-form-field  class="example-full-width password adc-w-100">
                                <mat-label>Confirm Password</mat-label>
                                <input required matInput type="password" formControlName = "confirmPassword" [ngClass]="{ 'is-invalid': isSubmitted && j.confirmPassword.errors }">
                                <mat-error *ngIf="checkPasswordReg('confirmPassword', 'required')">Confirm Password is required</mat-error>
                                <mat-error *ngIf="checkPasswordReg('confirmPassword', 'confirmedValidator')">Password must match</mat-error>
                              </mat-form-field>
                            </p>
                            <div class="text-center">
                              <button mat-raised-button color = "primary" class=" text-uppercase" type="submit">Save</button>   
                            </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>